<h2 mat-dialog-title i18n="@@feedback.picker.title">Select field for feedback</h2>
<mat-dialog-content>
  <p i18n="@@feedback.picker.description">Select the field you want to give feedback about:</p>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label i18n="@@feedback.picker.fieldLabel">Field</mat-label>
    <mat-select [(ngModel)]="selectedIndex">
      @for (field of selectableFields; track $index) {
        <mat-option [value]="$index">
          {{ field.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (selectedIndex !== null && selectableFields[selectedIndex].oid !== 'general' && selectableFields[selectedIndex].value) {
    <div class="selected-value">{{ selectableFields[selectedIndex].value }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" i18n="@@common.cancel">Cancel</button>
  <button mat-raised-button color="primary" (click)="proceed()"
          [disabled]="selectedIndex === null" i18n="@@feedback.picker.proceed">
    Continue to Feedback
  </button>
</mat-dialog-actions>
